import React, { useState, useEffect, useRef, useMemo } from 'react';
import Modal from 'react-modal';
import api from '~/services/api';
import {
  Container,
  AcessoCard,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalButton,
} from './styles';

Modal.setAppElement('#root');
import { Label, Input, Select } from '~/componentes/CustomForm';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import { Colors } from '~/config/Colors';
import sistemaListStore from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

function AcessosList({ idCliente, defaultData = [] }) {
  const customStoreValue = useMemo(
    () => ({
      state: {
        globalData: [],
        entityData: {},
        modal: { create: false, edit: false, editShow: false, show: false },
        data: [],
        selectValues: {},
        inputs: [],
        selects: [],
        requests: {
          findAll: async () => {},
          findOne: async () => {},
          deleteOne: async () => {},
          restoreOne: async () => {},
        },
        reloadData: () => {},
        createModalButton: false,
        createModalButtonT: false,
      },
      dispatch: () => {},
    }),
    [],
  );
  const [acessos, setAcessos] = useState(defaultData);
  const [portais, setPortais] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [acessoEditando, setAcessoEditando] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const formRef = useRef(null);

  useEffect(() => {
    carregarPortais();
  }, []);

  useEffect(() => {
    if (idCliente) {
      carregarAcessos();
    }
  }, [idCliente]);

  const carregarPortais = async () => {
    try {
      const response = await api.get('/signed/empresa/gestorprojeto/gerencia/portais', {
        params: { ativo: true },
      });
      setPortais(response?.data || []);
    } catch (error) {
      console.error('Erro ao carregar portais:', error);
    }
  };

  const carregarAcessos = async () => {
    try {
      const response = await api.get('/signed/empresa/gestorprojeto/cliente/portalrhlogins', {
        params: { idCliente },
      });
      setAcessos(response?.data || []);
    } catch (error) {
      console.error('Erro ao carregar acessos:', error);
    }
  };

  const abrirModal = (acesso = null) => {
    setAcessoEditando(acesso);
    setModalKey(prev => prev + 1);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setAcessoEditando(null);
  };

  const salvarAcesso = async () => {
    if (!formRef.current) return;

    const formElements = formRef.current.elements;
    const login = formElements.login?.value;
    const loginApi = formElements.loginApi?.value;
    const portal = formElements.portal?.value;
    const ativo = formElements.ativo?.value;

    if (!login || !loginApi || !portal) {
      alert('Preencha todos os campos obrigatórios');
      return;
    }

    return ShowConfirmacao(
      async () => {
        const dados = {
          login,
          loginApi,
          portal,
          idCliente,
          ativo: ativo === 'true',
          ...(acessoEditando?.id ? { id: acessoEditando.id } : {}),
        };

        let response;
        if (acessoEditando?.id) {
          response = await api.put('/signed/empresa/gestorprojeto/cliente/portalrhlogin', dados);
        } else {
          response = await api.post('/signed/empresa/gestorprojeto/cliente/portalrhlogin', dados);
        }

        if (response?.status === 200) {
          fecharModal();
          carregarAcessos();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            acessoEditando ? 'atualizar' : 'cadastrar'
          } esse acesso.`,
        },
        message: `Tem certeza que deseja ${
          acessoEditando ? 'atualizar' : 'cadastrar'
        } esse acesso?`,
        successModal: `Acesso ${acessoEditando ? 'atualizado' : 'cadastrado'} com sucesso!`,
      },
    );
  };

  const excluirAcesso = async acesso => {
    return ShowConfirmacao(
      async () => {
        const response = await api.delete('/signed/empresa/gestorprojeto/cliente/portalrhlogin', {
          data: { id: acesso.id },
        });

        if (response?.status === 200) {
          carregarAcessos();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: 'Ocorreu um erro ao excluir esse acesso.',
        },
        message: 'Tem certeza que deseja excluir esse acesso?',
        successModal: 'Acesso excluído com sucesso!',
      },
    );
  };

  if (!idCliente) {
    return (
      <Container>
        <div style={{ textAlign: 'center', padding: '2em', color: Colors.Color7 }}>
          <p>Salve o cliente primeiro para gerenciar os acessos ao Portal RH</p>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="header-acessos">
        <h3>Liberar acesso aos Portais</h3>
        <button type="button" className="btn-adicionar" onClick={() => abrirModal()}>
          <span className="material-icons">add</span>
          Novo Acesso
        </button>
      </div>

      <div className="lista-acessos">
        {acessos.length === 0 ? (
          <div className="empty-state">
            <span className="material-icons">lock_open</span>
            <p>Nenhum acesso cadastrado</p>
            <small>Clique em &quot;Novo Acesso&quot; para criar o primeiro acesso</small>
          </div>
        ) : (
          acessos.map(acesso => (
            <AcessoCard key={acesso.id} ativo={acesso.ativo} onClick={() => abrirModal(acesso)}>
              <div className="card-header">
                <div className="login-info">
                  <span className="material-icons">person</span>
                  <div>
                    <p className="login-principal">{acesso.login}</p>
                    <p className="login-api">API: {acesso.loginApi}</p>
                  </div>
                </div>
                <div className="badge-status" data-ativo={acesso.ativo}>
                  {acesso.ativo ? 'Ativo' : 'Inativo'}
                </div>
              </div>
              <div className="card-body">
                <div className="portal-info">
                  <span className="material-icons">web</span>
                  <p>{acesso.portal}</p>
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="button"
                  className="btn-editar"
                  onClick={e => {
                    e.stopPropagation();
                    abrirModal(acesso);
                  }}
                >
                  <span className="material-icons">edit</span>
                  Editar
                </button>
                <button
                  type="button"
                  className="btn-excluir"
                  onClick={e => {
                    e.stopPropagation();
                    excluirAcesso(acesso);
                  }}
                >
                  <span className="material-icons">delete</span>
                  Excluir
                </button>
              </div>
            </AcessoCard>
          ))
        )}
      </div>

      <sistemaListStore.Provider value={customStoreValue}>
        <Modal
          isOpen={modalAberto}
          onRequestClose={fecharModal}
          style={{
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
              zIndex: 9999,
            },
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              padding: 0,
              border: 'none',
              borderRadius: '12px',
              maxWidth: '750px',
              width: '90%',
              maxHeight: '90vh',
              background: 'transparent',
            },
          }}
        >
          <ModalContent>
            <ModalHeader>
              <ModalTitle>{acessoEditando ? 'Editar Acesso' : 'Novo Acesso'}</ModalTitle>
              <ModalCloseButton type="button" onClick={fecharModal}>
                ✕
              </ModalCloseButton>
            </ModalHeader>
            <form ref={formRef} key={modalKey}>
              <Materialize>
                <ModalBody>
                  <div className="row">
                    <Label title="Login (usado no Portal RH) *" className="col s12 m8 l8">
                      <Input
                        name="login"
                        defaultValue={acessoEditando?.login || ''}
                        placeholder="Ex: joao_clienteA"
                      />
                    </Label>
                    <Label title="Portal *" className="col s12 m4 l4">
                      <Select
                        name="portal"
                        list={{
                          list: portais,
                          value: 'titulo',
                          label: 'titulo',
                        }}
                        defaultValue={acessoEditando?.portal || ''}
                      />
                    </Label>
                  </div>
                  <div className="row">
                    <Label title="Login da API Protheus *" className="col s12 m8 l8">
                      <Input
                        name="loginApi"
                        defaultValue={acessoEditando?.loginApi || ''}
                        placeholder="Ex: joao"
                      />
                    </Label>
                    <Label title="Ativo *" className="col s12 m4 l4">
                      <Select
                        name="ativo"
                        isString
                        list={{
                          list: [
                            { id: 'true', titulo: 'Sim' },
                            { id: 'false', titulo: 'Não' },
                          ],
                          value: 'id',
                          label: 'titulo',
                        }}
                        defaultValue={acessoEditando?.ativo?.toString() || 'true'}
                      />
                    </Label>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <ModalButton secondary type="button" onClick={fecharModal}>
                    Cancelar
                  </ModalButton>
                  <ModalButton type="button" onClick={salvarAcesso}>
                    {/* <span className="material-icons">save</span> */}
                    Salvar
                  </ModalButton>
                </ModalFooter>
              </Materialize>
            </form>
          </ModalContent>
        </Modal>
      </sistemaListStore.Provider>
    </Container>
  );
}

export default AcessosList;
